import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';
import moment from "moment";
import {getApiDomain} from "../../util/domains";

//Obtener las sedes
export async function fetchBranchOffices({ commit, state }) {
    await $http.get('/api/sedes')
        .then((response) => {
            commit('setBranchOffices', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
            commit('BranchOfficeError', error.message)
        })
}

//cuentas para select Desde
export async function fetchAccountsFrom(
    { commit, state },
    requestParameters = { params: state.params_accounts_from }
) {
    await $http
        .get("/api/cuentas", requestParameters)
        .then(response => {
            commit("setAccountsFrom", response.data.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

//cuentas para select Hasta
export async function fetchAccountsUp(
    { commit, state },
    requestParameters = { params: state.params_accounts_up }
) {
    await $http
        .get("/api/cuentas", requestParameters)
        .then(response => {
            commit("setAccountsUp", response.data.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function fetchContactWarehouses(
    { commit, state },
    requestParameters = { params: state.params_contact_warehouse }
) {
    await $http
        .get("/api/sucursales", requestParameters)
        .then(response => {
            commit("setContactWarehouses", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

//Obtener los terceros
export async function fetchContacts({commit, state}, query) {

    if (query.length < 3) return;

    let params = { query }

    await $http.get('/api/terceros-lite', { params })
        .then((response) => {
            commit('setContacts', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('contactError', error.message)
        })
}

// obtener los tipos de comprobante
export async function fetchVouchertype({commit, state}) {
    await $http.get('/api/tipos-de-comprobantes', { params : state.paramsVoucherType})
        .then((response) => {
            commit('setVouchersTypes', response.data.data)
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

// obtener Data libro Contable
export async function fetchAuxiliaryBook({commit, state,dispatch}) {
    state.loading_report = true;
    state.params.download = null;

    await $http.get('/api/libro-auxiliar', { params : state.params})
        .then((response) => {
            if (response.data.limit_rows){
                Notification.warning({
                    title: 'Warning!',
                    message: 'La información supera los 50 mil registros, el Reprote completo se Descargara ' +
                        'Automaticamente en formato Excel',
                    type: 'error',
                    duration: 10000,
                    customClass: 'notification-box',
                });
                state.loading_report = false;
                commit("setauxiliary_book",[])
                dispatch("fetchAuxiliaryBookExcel");
               /* commit("setRequiredFields",true)*/

            }else{
               /* commit("setRequiredFields",false)*/
                commit("setauxiliary_book",response.data.data)
                state.loading_report = false;
                state.params.download = null;
            }

        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}
export async function fetchAuxiliaryBookExcel({commit, state}) {
    state.params.download = true;
    state.loading.module = true;

    await $http({
        url: `/api/libro-auxiliar`,
        method: 'GET',
        params: state.params,
    }).then(response => {
        state.loading = false;
        state.params.download = null;
        const url = response.data.path
        const link = document.createElement('a');
        link.href = getApiDomain()+url;
        let date= new Date();
        link.setAttribute('download', `Libro-Auxiliar-${moment(date).format("YYYY-MM-DD hh-mm-ss")}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();

    }).catch((error) => {
        state.loading = false;
        Notification.error({
            title: "Error!",
            message: error.response.data.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
    })
}
export async function fetchData({ commit,state }, params_ag) {
    state.params.page = params_ag.page
    state.params.filter_model = params_ag.filter_model
    try {
        // Realiza la llamada al API utilizando Axios
        const response = await $http.get('/api/libro-auxiliar', {
            params: state.params
        });
        return response.data.data;
    } catch (error) {
        // Si ocurre un error, lanza una excepción para que el componente pueda manejarlo
        throw new Error('Error al cargar datos desde el API:', error);
    }
}





// WEBPACK FOOTER //
// ./src/modules/auxiliary-book/actions.js